import BaseModelAPI from '../BaseModelAPI';

export default class ProductionStandarTimeList extends BaseModelAPI {

	static entity = 'productionstandartimelist'
	static entityName = 'productionstandartime';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
